/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Faq_Start_QInputs */

const en_mk_tb_faq_start_q = /** @type {(inputs: Mk_Tb_Faq_Start_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do we need a finished PRD to start as a team?`)
};

const id_mk_tb_faq_start_q = /** @type {(inputs: Mk_Tb_Faq_Start_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah tim harus sudah punya PRD lengkap?`)
};

/**
* | output |
* | --- |
* | "Do we need a finished PRD to start as a team?" |
*
* @param {Mk_Tb_Faq_Start_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_faq_start_q = /** @type {((inputs?: Mk_Tb_Faq_Start_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Faq_Start_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_faq_start_q(inputs)
	return en_mk_tb_faq_start_q(inputs)
});